var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 -0.000976562H22V11.999H4V-0.000976562ZM13 2.99902C13.7956 2.99902 14.5587 3.31509 15.1213 3.8777C15.6839 4.44031 16 5.20337 16 5.99902C16 6.79467 15.6839 7.55773 15.1213 8.12034C14.5587 8.68295 13.7956 8.99902 13 8.99902C12.2044 8.99902 11.4413 8.68295 10.8787 8.12034C10.3161 7.55773 10 6.79467 10 5.99902C10 5.20337 10.3161 4.44031 10.8787 3.8777C11.4413 3.31509 12.2044 2.99902 13 2.99902ZM8 1.99902C8 2.52946 7.78929 3.03816 7.41421 3.41324C7.03914 3.78831 6.53043 3.99902 6 3.99902V7.99902C6.53043 7.99902 7.03914 8.20974 7.41421 8.58481C7.78929 8.95988 8 9.46859 8 9.99902H18C18 9.46859 18.2107 8.95988 18.5858 8.58481C18.9609 8.20974 19.4696 7.99902 20 7.99902V3.99902C19.4696 3.99902 18.9609 3.78831 18.5858 3.41324C18.2107 3.03816 18 2.52946 18 1.99902H8ZM0 3.99902H2V13.999H18V15.999H0V3.99902Z",
    fill: "#5D6B72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.421ccb55.svg";
export { ForwardRef as ReactComponent };